<template>
  <div v-loading="loading" class="affiliate-status-affiliated-user-list">
    <el-row v-if="affiliatedUserDataList.length > 0">
      <el-col>
        <h3>ユーザー個別利用状況</h3>
        <div v-for="(affiliatedUserData, index) in affiliatedUserDataList" :key="index">

          <div v-loading="loading" class="affiliate-status-affiliated-user-list-affiliated-user-data">
            <el-row>
              <el-col>
                <h4>獲得NO：{{ affiliatedUserData.affiliatedId }}</h4>
                <table class="af-pop">
                  <tr>
                    <th>登録日</th>
                    <td>{{ affiliatedUserData.registeredAt }}</td>
                    <th>残ポイント</th>
                    <td>{{ affiliatedUserData.stockPoints | localeNum }}</td>
                  </tr>
                  <tr>
                    <th>自動更新設定</th>
                    <td>
                      <span v-if="affiliatedUserData.subscriptionStatus === true">ON</span>
                      <span v-else>OFF</span>
                    </td>
                    <th>設定中の自動更新プラン</th>
                    <td>{{ affiliatedUserData.planName }}</td>
                  </tr>
                </table>
                <div style="text-align: right; margin-top: 5px">
                  「設定中の自動更新プラン」は自動更新を設定中のプランが表示されます。
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <h4>決済情報</h4>
                <table class="af-pop">
                  <tr v-for="(
settlementData, settlementIndex
            ) in affiliatedUserData.settlementList" :key="settlementIndex">
                    <th>{{ settlementData.planName }}</th>
                    <td>{{ settlementData.times }}</td>
                  </tr>
                </table>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col v-for="(toolData, toolIndex) in affiliatedUserData.toolDataList" :key="toolIndex" :span="12">
                <h4>{{ toolData.toolName }}</h4>
                <table class="af-pop">
                  <tr>
                    <th style="width: 70%;">利用設定</th>
                    <td>
                      <span v-if="toolData.isActive === true">ON</span>
                      <span v-else>OFF</span>
                    </td>
                  </tr>
                </table>
                <table class="af-pop" style="margin-top: 20px;">
                  <thead>
                    <tr>
                      <th>ステップ</th>
                      <th>達成ステータス</th>
                      <th>達成日時</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(bonusData, bonusIndex) in toolData.bonusDataList" :key="bonusIndex">
                      <th>{{ bonusData.name }}</th>
                      <td>
                        <span v-if="bonusData.status === '0'">×</span>
                        <span v-else-if="bonusData.status === '1'">○</span>
                      </td>
                      <td>{{ bonusData.getDatetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </el-col>
            </el-row>
          </div>
          <hr style="margin: 100px 0;" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AffiliateStatusAffiliatedUserList",
  components: {
    // 
  },
  props: {
    dateRange: Array
  },
  data() {
    return {
      loading: true,
      affiliatedUserDataList: []
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
  },
  watch: {
    dateRange: {
      handler(newDateRange) {
        this.getAffiliatedUserDataList(newDateRange);
      },
      immediate: true,
    },
  },
  methods: {
    getAffiliatedUserDataList(dateRange) {
      // 
      this.loading = true;

      // 
      this.$axios
        .get(`${this.rt}/l/api/affiliate/get-affiliated-user-data-list?date_range=${encodeURIComponent(JSON.stringify(dateRange))}`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            console.log("========= response.data.affiliatedUserDataList =========");
            console.log(response.data)
            this.affiliatedUserDataList = response.data.affiliatedUserDataList;
          } else if (response.data.status === 400) {
            alert(response.data.message);
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push('/login');
          } else {
            alert(this.apiErrorMessage);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped></style>
